import React, { useState, useEffect, useCallback } from "react";
import { Row, Label } from "reactstrap";

import { CustomModal } from "../../../components/CustomModal";
import { AutoComplete } from "../../../components/AutoComplete";
import { customStyles } from "../../UserManagement/CustomStyles";
import { CustomButton } from "../../../components/CustomButton";
import { STATUS_OPTIONS } from "../Config";

const OnboardingAudioFilterModal = ({
    isModalOpen,
    handleClose,
    handleApplyFilter,
    selectedFilters
}) => {
    const [localFilters, setLocalFilters] = useState(selectedFilters);

    useEffect(() => {
        setLocalFilters(selectedFilters); // Sync local state when filters change
    }, [selectedFilters]);

    const handleChange = (key, value) => {
        setLocalFilters((prev) => ({
            ...prev,
            [key]: value
        }));
    };

    const handleSubmit = () => {
        handleApplyFilter(localFilters);
        handleClose(false);
    };

    const renderAutoComplete = useCallback(
        (label, placeholder, key, options, isLoading) => (
            <Row className="my-2">
                <Label className="mb-1 fw-bold">{label}</Label>
                <AutoComplete
                    handleScroll={null}
                    customStyles={customStyles.filter}
                    options={options}
                    onChange={(value) => handleChange(key, value)}
                    value={localFilters[key]}
                    placeholder={placeholder}
                    isClearable
                    isMulti={false}
                    maxMenuHeight={220}
                    isLoading={isLoading}
                    classNamePrefix="status-header-search-admin"
                    theme={(theme) => ({
                        ...theme,
                        colors: {
                            ...theme.colors,
                            primary: "#2795ae"
                        }
                    })}
                />
            </Row>
        ),
        [localFilters]
    );

    return (
        <CustomModal
            isOpen={isModalOpen}
            size="md"
            className="filter-modal"
            modalBodyClasses="d-flex justify-content-center"
            customButton
            modalTitle={<h2 className="m-0 px-2">Audio Filter</h2>}
            handleModalToggling={() => handleClose(false)}
        >
            <div>
                {renderAutoComplete("Status", "Select status", "status", STATUS_OPTIONS, false)}

                <div className="d-flex justify-content-evenly w-100 my-2 mt-4">
                    <CustomButton
                        title="Cancel"
                        className="me-3 custom-btn-sm"
                        color="primary"
                        outline
                        onClick={() => handleClose(false)}
                    />
                    <CustomButton
                        title="Apply"
                        color="primary"
                        className="shadow-theme grad-primary"
                        onClick={handleSubmit}
                    />
                </div>
            </div>
        </CustomModal>
    );
};

export default OnboardingAudioFilterModal;
